import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateEventCategory } from "../api/queries";
import { EventCategoryForm } from "../ui/EventCategoryForm";

export function EventCategoryCreatePage() {
  const nav = useNavigate({
    from: "/app/performance/settings/event-categories/create",
  });
  const createCategory = useCreateEventCategory();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ຫມວດງານສະແດງ",
              to: "/app/performance/settings/event-categories",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມຫມວດງານ</h2>
        </div>
        <div className="rounded-xl border bg-card px-6">
          <EventCategoryForm
            onSubmit={async (vals) => {
              try {
                const created = await createCategory.mutateAsync(vals);
                nav({
                  to: "/app/performance/settings/event-categories/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/settings/event-categories" })
            }
            submitting={createCategory.isPending}
          />
        </div>
      </Main>
    </>
  );
}
